import { carrierBuildQuestionsV1 } from "./versions/questions.v1";
import { carrierBuildQuestionsV2 } from "./versions/questions.v2";
import { carrierBuildQuestionsV3 } from "./versions/questions.v3";

export type QuestionFormKey =
	| "1_MillBuilding.Date"
	| "2_MillBuilding.Shift"
	| "3_MillBuilding.IDNumber"
	| "4_MillBuilding.Section"
	| "5_MillBuilding.MillType"
	| "6_MillBuilding.RougherStand"
	| "7_MillBuilding.FullBodyType"
	| "8_MillBuilding.ChockSize"
	| "9_MillBuilding.ShortChockBait"
	| "10_MillBuilding.FinishStand"
	| "11_MillBuilding.StandNumber"
	| "12_MillBuilding.TopArborNumber"
	| "13_MillBuilding.BottomArborNumber"
	| "14_MillBuilding.RollSetLetter"
	| "15_MillBuilding.SetBait"
	| "16_MillBuilding.BaitInstalled"
	| "17_MillBuilding.BottomWaterPipes"
	| "18_MillBuilding.SetBottomRoll"
	| "19_MillBuilding.CheckBaitMeasurement"
	| "20_MillBuilding.RecordMeasurement"
	| "21_MillBuilding.SetCassetteHousing"
	| "22_MillBuilding.SetApex"
	| "23_MillBuilding.CassetteHousingTight"
	| "24_MillBuilding.CassetteWaterAirLines"
	| "25_MillBuilding.SetTopRoll"
	| "26_MillBuilding.RollsLinedUp"
	| "27_MillBuilding.TurnbucklesTight"
	| "28_MillBuilding.SetBottomGuides"
	| "29_MillBuilding.TopWaterPipe"
	| "30_MillBuilding.BottomGuidesSprings"
	| "31_MillBuilding.BottomGuideBubbleLevel"
	| "32_MillBuilding.SetTopGuides"
	| "33_MillBuilding.TopGuidesSprings"
	| "34_MillBuilding.GuidesParting"
	| "35_MillBuilding.SetDelivery"
	| "36_MillBuilding.DeliveryTight"
	| "37_MillBuilding.DeliveryWidth"
	| "38_MillBuilding.DeliveryHoldDownClip"
	| "39_MillBuilding.SetEntry"
	| "40_MillBuilding.EntryTight"
	| "41_MillBuilding.EntryWidth"
	| "42_MillBuilding.EntryHoldDownClip"
	| "43_MillBuilding.EntryBlockedWithWood"
	| "44_MillBuilding.CassetteParting"
	| "45_MillBuilding.StandIdentification"
	| "46_MillBuilding.EmployeeClockNumbers"
	| "47_MillBuilding.ForemanName"
	| "48_MillBuilding.Housekeeping"
	| "49_Passes.RollsPass"
	| "50_MillBuilding.RecordMeasurement"
	| "RollsetId";

export interface Question {
	order: number;
	key: QuestionFormKey;
	text: string;
	type:
		| "text"
		| "number"
		| "date"
		| "options"
		| "section"
		| "boolean"
		| "stand"
		| "rollset"
		| "arbor"
		| "rollsPass";
	options?: string[];
	nextQuestion: string | Record<string, string> | null;
	numberGroup?: string;
	millTypeKey?: QuestionFormKey;
}

export const LAST_CARRIER_BUILD_FORM_VERSION = 3;

const questionsByFormVersion: Record<number, Question[]> = {
	1: carrierBuildQuestionsV1,
	2: carrierBuildQuestionsV2,
	3: carrierBuildQuestionsV3,
};

export const getCarrierBuildQuestions = (
	formVersion?: number | null,
): Question[] => {
	if (formVersion == null) return questionsByFormVersion[1];
	return (
		questionsByFormVersion[formVersion] ??
		questionsByFormVersion[LAST_CARRIER_BUILD_FORM_VERSION]
	);
};

export const getQuestionNumbers = (questions: Question[]): string[] => {
	const numbers: string[] = [];
	let currentNumber = 0;

	questions.forEach((question, index) => {
		const group = question.numberGroup;
		const continuesGroup =
			group != null && group === questions[index - 1]?.numberGroup;

		if (!continuesGroup) {
			currentNumber++;
		}

		numbers.push(`${currentNumber}`);
	});

	return numbers;
};

export const getNextQuestionKey = (
	question: Question,
	selectedAnswer: any,
	answers?: Record<string, any>,
): string | null => {
	if (question.nextQuestion === null) {
		return null;
	}
	if (typeof question.nextQuestion === "string") {
		return question.nextQuestion || null;
	} else if (typeof question.nextQuestion === "object") {
		const branchAnswer = question.millTypeKey
			? answers?.[question.millTypeKey]
			: selectedAnswer;
		if (branchAnswer != null) {
			return question.nextQuestion[branchAnswer] || null;
		}
	}
	return null;
};
